(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProgramaEducativoDialogController', ProgramaEducativoDialogController);

    ProgramaEducativoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProgramaEducativo'];

    function ProgramaEducativoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProgramaEducativo) {
        var vm = this;

        vm.programaEducativo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.programaEducativo.id !== null) {
                ProgramaEducativo.update(vm.programaEducativo, onSaveSuccess, onSaveError);
            } else {
                ProgramaEducativo.save(vm.programaEducativo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:programaEducativoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
